/* eslint-disable no-unused-expressions */
import {
    HomeOutlined,
    UsergroupAddOutlined,
    UserAddOutlined,
    UserOutlined,
    FileTextOutlined,
        WalletOutlined,
        SettingOutlined,
        EyeOutlined,
        FileProtectOutlined,
        CreditCardOutlined
  } from "@ant-design/icons";
//   import categoryIcon from '../../images/categoryIcon.svg'
  import Vector1 from '../../images/Vector1.svg'
  import Vector2 from '../../images/Vector2.svg'
  import roles from '../../images/roles.svg'
  import { NavLink } from 'react-router-dom';
 
export const MenuItems = [
    {
        name: 'Dashboard',
        url: '/dashboard',
        icon: <HomeOutlined />,
        key: '3',
    },
    // {
    //     name: 'Profile',
    //     url: '/profile',
    //     icon: <UsergroupAddOutlined />,
    //     key: '4'
    // }, 
    {
        name: 'Manage Roles',
        url: '/manage-roles',
        icon: <img src={roles} alt="roles" style={{color: 'black'}} />,
        key: '25',
    },
    {
        name: 'Manage Users',
        url: '/manage-users',
        icon: <UserAddOutlined />,
        key: '5',
    },
    {
        name: 'Wallet',
        url: '/wallet',
        icon: <WalletOutlined />,
        key: '8',
    },
    {
        name: 'Bills Payment',
        url: '/bills-payment',
        icon: <FileProtectOutlined />,
        key: '180',
    },
    {
        name: 'Bulk Airtime',
        url: '/bulk-airtime',
        icon: <CreditCardOutlined />,
        key: '280',
    },
    {
        name: 'Commission',
        url: '/commission',
        icon: <img src={Vector2} alt="vector2-icon" />,
        key: '18',
    },
    {
        name: 'Products',
        url: '/products',
        icon: <img src={Vector1} alt="vector1-icon" />,
        key: '19',
    }
    ,{
        name: 'Billers',
        url: '/billers',
        icon: <UserOutlined />,
        key: '6',
    },
    {
        name: 'Reports',
        url: '/reports',
        icon: <FileTextOutlined />,
        key: '7',
    },
   
    {
        name: 'Settings',
        url: '',
        icon: <SettingOutlined />,
        key: '9',
        sub: [
            {
                name: "Merchant Settings",
                url: "/merchant-settings",
                key: "99"
            },
            {
                name: "User Settings",
                url: "/user-settings",
                key: "100"
            }
        ]
    },
    {
        name: "Audit Logs",
        url: "/audit-logs",
        icon: <EyeOutlined />,
        key: "11",
      }
].map((x) =>({ 
        label: (<NavLink to={x.url}>{x.name}</NavLink>),
        icon: x.icon,
        key: x.key,
        children: x.sub?.map(y => ({
            label: (<NavLink to={y.url}>{y.name}</NavLink>),
            key: y.key
        }))
}))